import PrintersPageView from "./PrintersPageView";

function PrintersPage() {
  return <PrintersPageView />;
}

export default PrintersPage;